const pad = (value) => String(value).padStart(2, '0')

export const getTimestampedFilename = (baseName, extension = 'xlsx', date = new Date()) => {
  const timestamp = [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds()),
  ].join('')
  return `${baseName}-${timestamp}.${extension}`
}

export const downloadBlob = (blob, filename = 'download.xlsx') => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
